function install (Vue) {
  const user = {
    name: null,
    email: null,
    id: null,
    imageUrl: null
  }

  Vue.prototype.$auth = {
    isAuthenticated () {
      return localStorage.getItem('gapi.expires_at') !== null
    },

    getUser () {
      if (!this.isAuthenticated()) {
        return user
      }
      user.email = localStorage.getItem('gapi.email')
      user.name = localStorage.getItem('gapi.full_name')
      user.imageUrl = localStorage.getItem('gapi.image_url')
      user.id = parseInt(localStorage.getItem('userId'))
      return user
    },

    getIdToken () {
      return localStorage.getItem('gapi.id_token')
    },

    setId (id) {
      if (!id) {
        localStorage.removeItem('userId')
      } else {
        localStorage.setItem('userId', id)
      }
    },

    logout () {
      localStorage.removeItem('gapi.access_token')
      localStorage.removeItem('gapi.id_token')
      localStorage.removeItem('gapi.expires_at')
      localStorage.removeItem('gapi.id')
      localStorage.removeItem('gapi.full_name')
      localStorage.removeItem('gapi.first_name')
      localStorage.removeItem('gapi.last_name')
      localStorage.removeItem('gapi.image_url')
      localStorage.removeItem('gapi.email')
    }
  }
}

export default { install }
